import Vue from 'vue'
import moment from 'moment';

Vue.filter('telefone', function (value) {
  if (!value) return value
  if (value.length === 10) {
    return '(' + value.substring(0, 2) + ')' + value.substring(2, 6) + '-' + value.substring(6, 10)
  } else if (value.length === 11) {
    return '(' + value.substring(0, 2) + ')' + value.substring(2, 7) + '-' + value.substring(7, 11)
  }
  return value
})

Vue.filter('cpfcnpj', function (value) {
  if (!value) return value
  value = value.replace(/\D/g, '')             // Remove tudo o que não é dígito
  if (value.length === 14) {
    value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5') // CNPJ
  } else {
    value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4') // CPF
  }
  return value
})

Vue.filter('typepessoa', function (value) {
  if (!value) return value
  if (value === 'F') { return 'Física' }
  if (value === 'J') { return 'Jurídica' }
  return value
})

Vue.filter('data', function (value) {
  if (!value) return value
  return moment(String(value)).format('DD/MM/YYYY')
})

Vue.filter('datahora', function (value) {
  if (!value) return value
  return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
})

Vue.filter('currency', function (value) {
  if (value === null) return value

  let formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  })

  return formatter.format(value)
  return 'R$ ' + parseFloat(value).toFixed(2);
})

Vue.filter('truncate', function (text, length, suffix) {
  if (text.length > length) {
      return text.substring(0, length) + suffix;
  } else {
      return text;
  }
});


// WEBPACK FOOTER //
// ./src/filters/index.js